import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';

// Hooks
import { useTenant } from '../../../../../hooks/useTenant';
import useProfileAttendance from '../../hooks/useProfileAttendance';
import useAttendanceStats from '../../hooks/useAttendanceStats';

// Components locais do módulo de frequência
import AttendanceFilters from '../Attendance/AttendanceFilters';
import AttendanceStatsCards from '../Attendance/AttendanceStatsCards';
import AttendanceChart from '../Attendance/AttendanceChart';
import { getAttendanceColumns } from '../Attendance/AttendanceColumns';

// Componentes comuns
import DataTable from '../../../../../components/Common/DataTable';

/**
 * ProfileAttendance
 * Exibe histórico de frequência do aluno com filtros de período.
 * Agrega componentes separados por responsabilidade (Filtros, Estatísticas, Gráfico, Tabela).
 */
const ProfileAttendance = ({ member }) => {
    const { idTenant, tenantSettings } = useTenant();

    // 1. Controle de dados de Frequência (Firestore + Filtros de período)
    const {
        filteredLogs,
        loading,
        filter,
        activeRange,
        customRange,
        handleFilterChange,
        handleCustomRange
    } = useProfileAttendance(idTenant, member.id);

    // 2. Extração de estatísticas e cálculos de desempenho (Hook local)
    const {
        consecutiveAbsences,
        weeklyAverageStr,
        periodStats
    } = useAttendanceStats(member, filteredLogs);

    // 3. Regra de negócio (Tenant settings)
    const absenceRiskThreshold = tenantSettings?.businessRules?.absenceRiskThreshold || 3;
    const isHighRisk = consecutiveAbsences >= absenceRiskThreshold;
    const riskLevel = isHighRisk ? "Alto" : "Baixo";

    const columns = getAttendanceColumns();

    return (
        <Card className="border-0 shadow-sm mt-4 rounded-0 overflow-hidden">
            {/* Header + Filtros + Gráfico + Stats */}
            <CardBody className="p-4 border-bottom bg-white">
                <AttendanceFilters
                    filter={filter}
                    customRange={customRange}
                    handleFilterChange={handleFilterChange}
                    handleCustomRange={handleCustomRange}
                />

                <AttendanceStatsCards
                    periodStats={periodStats}
                    weeklyAverageStr={weeklyAverageStr}
                    consecutiveAbsences={consecutiveAbsences}
                    isHighRisk={isHighRisk}
                    riskLevel={riskLevel}
                />

                <AttendanceChart
                    logs={filteredLogs}
                    startDate={activeRange.startDate}
                    endDate={activeRange.endDate}
                />
            </CardBody>

            {/* Tabela de Registros Recentes */}
            <CardBody className="p-0">
                <DataTable
                    columns={columns}
                    data={filteredLogs}
                    isLoading={loading}
                    emptyMessage="Nenhum registro de frequência encontrado"
                    emptySubMessage={filter !== "ALL" ? "Tente outro período ou selecione \"Tudo\"." : "A chamada ainda não foi realizada para este aluno."}
                />
            </CardBody>
        </Card>
    );
};

ProfileAttendance.propTypes = {
    member: PropTypes.object.isRequired
};

export default ProfileAttendance;
